module.exports = __webpack_public_path__ + "img/cloud.064de008.svg";